import React, { Suspense, lazy } from "react"
import { useSelector, } from 'react-redux'
import { Router, Switch, Route, } from "react-router-dom"
import { history } from "./history"

import Spinner from "../components/spinner/Loading-spinner"
import Header from "../components/header"
import Footer from "../components/footer"
import Copyright from "../components/copyright"

import "../assets/scss/main.scss"
// Route-based code splitting
// Errors
const Error404 = lazy(() => import("../views/errors/404"))
const Error500 = lazy(() => import("../views/errors/500"))
const NotAuthorized = lazy(() => import("../views/errors/notAuthorized"))

const CompanyAccount = lazy(() => import("../views/showcase/companyAccount"))
const CandidatAccount = lazy(() => import("../views/showcase/candidatAccount"))

const LostPassword = lazy(() => import("../views/showcase/lostPassword"))

const EditResume = lazy(() => import("../views/showcase/editResume"))
const GuestResume = lazy(() => import("../views/showcase/guestResume"))
const Favorites = lazy(() => import("../views/showcase/favorites"))
const AdvertisementList = lazy(() => import("../views/showcase/advertisementList"))
const EditAccount = lazy(() => import("../views/showcase/editAccount"))
const SearchResume = lazy(() => import("../views/showcase/searchResume"))
const Home = lazy(() => import("../views/showcase/home"))
const Tos = lazy(() => import("../views/showcase/tos"))

const Contact = lazy(() => import("../views/showcase/contact"))

// Set Layout and Component Using App Route
const AppRoute = ({ component: Component, permissions, path, action, ...rest }) => {
  const user = useSelector(state => state.api.user)
  permissions = parseInt(permissions)
  if (permissions !== 0 && ( !user || !(user.role & parseInt(permissions)))){
    Component = NotAuthorized
  }
  return (
    <Route
      {...rest}
      render={routeProps => {
        return (
          <>
            <Header />
            <Suspense fallback={<Spinner />}>
              <Component {...routeProps} {...{action}} />
            </Suspense>
            <Footer />
            <Copyright />
          </>
        )
      }}
    />
  )
}

const AppRouter = () => {
  return (
    // Set the directory path if you are deploying in sub-folder
    <Router history={history}>
      <Switch>
        <AppRoute path="/" component={Home} exact permissions="0" />
        <AppRoute path="/CGU" component={Tos} permissions="0" />
        <AppRoute path="/motDePassePerdu/:id/:token" component={LostPassword} permissions="0" action="reset" />
        <AppRoute path="/motDePassePerdu" component={LostPassword} permissions="0" />
        <AppRoute path="/creerCompteEntreprise" component={CompanyAccount} permissions="0" />
        <AppRoute path="/creerCompteCandidat" component={CandidatAccount} permissions="0" />
        <AppRoute path="/modifierMonCv" component={EditResume} permissions="1" />
        <AppRoute path="/cvInvites" component={GuestResume} permissions="6" />
        <AppRoute path="/favoris" component={Favorites} permissions="6" />
        <AppRoute path="/annonces" component={AdvertisementList} permissions="6" />
        <AppRoute path="/editerCompte" component={EditAccount} permissions="7" />
        <AppRoute path="/chercherCV" component={SearchResume} permissions="6" />
        <AppRoute path="/contact" component={Contact} permissions="0" />
        <AppRoute path="/activerCompte/:id/:hash" component={Home} permissions="0" action="activateAccount" />
        <AppRoute path="/404" component={Error404} permissions="0" />
        <AppRoute path="/500" component={Error500} permissions="0" />
        <AppRoute component={Error404} permissions="0" />
      </Switch>
    </Router>
  )
}

export default AppRouter
